import { motion } from "framer-motion";
import "../styles/heroes.css";

function Heroes() {
  return (
    <section id="hero" className="container-fluid hero-section">
      <div className="container pt-4">
        <div className="row align-items-center g-5">
          <motion.div
            className="col-sm-6 order-sm-2 order-1 d-flex justify-content-center hero-image-container"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <img
              src="images/hero-image.webp"
              className="hero-image"
              alt="Online marketing kisvállalkozásoknak – FRDYPromotions hero"
              decoding="async"
              loading="eager"
              width="1000"
              height="600"
              fetchpriority="high"
            />
          </motion.div>

          <motion.div
            className="col-sm-6 order-sm-1 order-2"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            <h1 className="display-5 fw-bold lh-1 mb-3 hero-title">
              Jól működő vállalkozásod van? Segítek a következő szintre lépni.
            </h1>

            <p className="lead hero-subtext">
              Olyan kisvállalkozásoknak segítek, akik már stabilan működnek – és
              most szeretnék tovább növelni a bevételüket az online hirdetések
              erejével.
            </p>

            <div className="d-grid gap-2 d-flex justify-content-center mt-3">
              <motion.a
                href="#about"
                className="btn btn-lg px-4 me-md-2 hero-button text-decoration-none"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
              >
                Tudj meg többet
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
      {/*<motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <div className="heroes-wave-divider">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
            <path
              d="M0,0 C480,100 960,0 1440,100 L1440,0 L0,0 Z"
              fill="#2C2F36"
            />
          </svg>
        </div>
      </motion.div>*/}
    </section>
  );
}

export default Heroes;
